import { render } from "./addDevice.vue?vue&type=template&id=4454ade5&scoped=true"
import script from "./addDevice.vue?vue&type=script&lang=js"
export * from "./addDevice.vue?vue&type=script&lang=js"

import "./addDevice.vue?vue&type=style&index=0&id=4454ade5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4454ade5"]])

export default __exports__